import sdl from '@jds/react-generated-sdl/JDSToast';
import type { JDSToastProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ToastProps } from '../logic';

const Component = (props: ToastProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    open = false,
    showClose = true,
    closeButtonAriaLabel = 'Close Toast',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { open, showClose, closeButtonAriaLabel, ...rest },
    'JDSToast',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Toast = withLogic(Component) as React.FC<ToastProps> & {
  slotName?: string;
};

Toast.displayName = 'Toast';
Toast.slotName = 'jds_toast';

export { Toast, type JDSToastProps };
